// extracted by extract-css-chunks-webpack-plugin
module.exports = {"screenReaderOnly":"screenReaderOnly_SfQZ9","productPrice":"productPrice_4mG1K"};